<div>
  <h2 style="margin: 5px 0 10px 0;">Create a New Consumer</h2>
  <form [formGroup]="form" novalidate (ngSubmit)="OnSubmit()">
    <div class="container">
      <div>
        <mat-form-field>
          <input
            matInput
            required
            placeholder="Consumer Name"
            formControlName="name"
            >
          @if (form.controls['name'].invalid) {
            <mat-error>Please enter a Name</mat-error>
          }
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <input
            formControlName="tag"
            matInput
            pattern="^[A-Z_0-9]*$"
            placeholder="Consumer Tag"
            required
            (focusout)="findTagExists()"
            >
          @if (form.controls['tag'].invalid && !form.controls['tag'].value) {
            <mat-error>
              Please enter a Standard Tag
            </mat-error>
          }
          @if (form.controls['tag'].errors?.pattern && form.controls['tag'].value) {
            <mat-error>
              Please enter a Valid Standard Tag
            </mat-error>
          }
          @if (form.controls['tag'].errors?.tagExists && form.controls['tag'].touched) {
            <mat-error>
              Tag already exists! Create a new one.
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="container">
      <div>
        <mat-form-field>
          <mat-select
            placeholder="Consumer Type"
            required
            formControlName="destinationType"
            >
            @for (consumerType of (consumerTypes$ | async); track consumerType) {
              <mat-option
                [value]="consumerType.tag"
                >
                {{ consumerType.name }}
              </mat-option>
            }
          </mat-select>
          @if (form.controls['destinationType'].invalid) {
            <mat-error>
              Please select a Consumer Type
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <mat-select
            placeholder="Sales Channels"
            required
            multiple
            formControlName="salesChannels">
            <mat-option
              [value]="'ORDERING'"
              [disabled]="true">
              In Store Price
            </mat-option>
            @for (channel of salesChannels; track channel) {
              <mat-option
                [value]="channel.tag">
                {{ channel.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="container">
      <mat-form-field class="flex-85" >
        <textarea
          formControlName="description"
          matInput
          matTextareaAutosize
          placeholder="Consumer Description"
          required
          maxlength="250"
        ></textarea>
        @if (form.controls['description'].invalid) {
          <mat-error>
            Please enter a Description
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div  style="margin-top: 30px;" class="flex-center-center">
      <button
        class="button-color"
        mat-raised-button
        matTooltip="Cancel Creating Consumer"
        style="margin-right: 60px;"
        type="button"
        (click)="onNoClick()"
        >Cancel
      </button>
      <button
        class="button-color"
        [disabled]="form.invalid"
        mat-raised-button
        matTooltip="Submit Consumer"
        type="submit"
        >Save
      </button>
    </div>
  </form>
</div>
